<div id="lista" class="page-layout carded fullwidth">

    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">

        <!-- HEADER -->
        <div class="header accent"
             fxLayout="column" fxLayoutAlign="center center"
             fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="space-between center">

            <!-- APP TITLE -->
            <div class="logo mb-24 mb-md-0"
                 fxLayout="row" fxLayoutAlign="start center">
                <mat-icon class="logo-icon s-32 mr-16">
                    notifications
                </mat-icon>
                <span class="logo-text h1">
                    Notificações
                </span>
            </div>
            <!-- / APP TITLE -->

             <!-- ADD BUTTON -->
            <button 
                mat-mini-fab
                matTooltip="ADICIONAR NOVA ESTRATÉGIA" 
                (click)="openFiltro()"
                class="add-product-button fuse-white mt-24 mt-md-0">
                <mat-icon>search</mat-icon>
                <span></span>
            </button>
         <!-- / ADD BUTTON -->

        </div>
        <!-- / HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <ngx-datatable 
                #table 
                class='material' 
                [loadingIndicator]="loadingIndicator"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"                       
                [footerHeight]="50" 
                (activate)="onActivate($event)"
                style="cursor: pointer;"
                [rows]='rows'>

                <ngx-datatable-column name="Data" prop="created_at" [sortable]="false" [width]="20">
                    <ng-template let-rowIndex="rowIndex" let-created_at="value" ngx-datatable-cell-template>
                        {{created_at | date:'dd/MM/yyyy H:mm'}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Categoria" prop="categoria" [sortable]="false" [width]="50">
                    <ng-template let-rowIndex="rowIndex" let-categoria="value" ngx-datatable-cell-template>
                        {{categoria.nome}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Titulo" prop="titulo" [sortable]="false" [width]="250">
                    <ng-template let-rowIndex="rowIndex" let-titulo="value" ngx-datatable-cell-template>
                        {{titulo}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="Assessor" prop="operador" [sortable]="false" [width]="50" *ngIf="this.user.role_id != 5">
                    <ng-template let-rowIndex="rowIndex" let-operador="value" ngx-datatable-cell-template>
                        {{operador.name}}
                    </ng-template>
                </ngx-datatable-column>                

                <ngx-datatable-column name="Escritório" prop="operador" [sortable]="false" [width]="50" *ngIf="this.user.role_id != 5 ">
                    <ng-template let-rowIndex="rowIndex" let-operador="value" ngx-datatable-cell-template>
                        {{(operador.escritorio_padrao!=null)? operador.escritorio_padrao.nome_fantasia : ""}}
                    </ng-template>
                </ngx-datatable-column>

                <ngx-datatable-column name="" prop="row" [sortable]="false" [width]="10">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <mat-icon class="confirmado" *ngIf="row.unread">check</mat-icon>
                    </ng-template>
                </ngx-datatable-column>                

            </ngx-datatable>

            <div style="padding: 5px 10px">
                <mat-paginator 
                    #paginator 
                    [length]="length"
                    [pageSize]="pageSize"
                    [pageSizeOptions]="pageSizeOptions"
                    (page)="pageEvent($event)">
                </mat-paginator>
            </div>
        </div>
    </div>
</div>
